var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyLogoOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7247 10.6666V12.5333C10.7247 13.28 10.7247 13.6534 10.5786 13.9386C10.45 14.1895 10.2449 14.3934 9.99267 14.5213C9.70588 14.6666 9.33045 14.6666 8.57959 14.6666H3.48495C2.73409 14.6666 2.35867 14.6666 2.07188 14.5213C1.81961 14.3934 1.61451 14.1895 1.48597 13.9386C1.33984 13.6534 1.33984 13.28 1.33984 12.5333V7.46659C1.33984 6.71985 1.33984 6.34648 1.48597 6.06126C1.61451 5.81038 1.81961 5.60641 2.07188 5.47858C2.35867 5.33325 2.73409 5.33325 3.48495 5.33325H5.36193M7.50704 10.6666H12.6017C13.3525 10.6666 13.728 10.6666 14.0148 10.5213C14.267 10.3934 14.4721 10.1895 14.6007 9.93857C14.7468 9.65336 14.7468 9.27999 14.7468 8.53325V3.46659C14.7468 2.71985 14.7468 2.34648 14.6007 2.06126C14.4721 1.81038 14.267 1.60641 14.0148 1.47858C13.728 1.33325 13.3525 1.33325 12.6017 1.33325H7.50704C6.75618 1.33325 6.38075 1.33325 6.09396 1.47858C5.84169 1.60641 5.63659 1.81038 5.50805 2.06126C5.36193 2.34648 5.36193 2.71985 5.36193 3.46659V8.53325C5.36193 9.27999 5.36193 9.65336 5.50805 9.93857C5.63659 10.1895 5.84169 10.3934 6.09396 10.5213C6.38075 10.6666 6.75618 10.6666 7.50704 10.6666Z",
    stroke: "#A39992",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLogoOff);
export default __webpack_public_path__ + "static/media/Copy-logo-off.2025bc766a5c96f389c82c4a752e24fc.svg";
export { ForwardRef as ReactComponent };